import { closeAllPopups, createPopup, openPopup, PLACEMENT } from 'ui/popup/popup';

import { on, unByKey } from 'cadenza/utils/event-util';

const MIN_DISTANCE_FROM_EDGE_FOR_ARROW = 30;

export class MapPopupHandler {

  _map;
  _popup;
  _closeOnInsideClick;

  _eventKeys = [];
  _draggingPointerOnPopup = false;

  constructor (map, { closeOnInsideClick = false } = {}) {
    this._map = map;
    this._closeOnInsideClick = closeOnInsideClick;
  }

  displayPopup (mapCoordinates, content, styleClass, verticalPopupOffset = 0) {
    closeAllPopups();

    const [ mapPixelX, mapPixelY ] = this._map.getPixelFromCoordinate(mapCoordinates);
    const mapBoundingClient = document.getElementById('map').getBoundingClientRect();

    this._popup = createPopup({ styleClass });
    this._popup.append(content);

    const adjustedX = mapPixelX + mapBoundingClient.x;
    // popup positions itself on the coordinates we give it, so it partially covers the address icon.
    // we adjust height and y to create a margin on the invisible DOMRect so the popup is offset a bit
    // and the address icon can be seen.
    const adjustedY = mapPixelY + mapBoundingClient.y - verticalPopupOffset;
    const height = 2 * verticalPopupOffset;

    openPopup(new DOMRect(adjustedX, adjustedY, 0, height), this._popup, {
      arrow: !this._isCloseToRightOrLeftMapEdge(mapPixelX),
      placement: PLACEMENT.BOTTOM,
      onOpen: () => this._onPopupOpen(),
      onClose: () => unByKey(this._eventKeys)
    });
  }

  _onPopupOpen () {
    this._eventKeys.push(on(document, 'click touchstart', () => {
      const closestPopup = event.target.closest('.d-popup');
      if (!closestPopup) {
        closeAllPopups();
      }
    }));
    if (this._closeOnInsideClick) {
      this._eventKeys.push(
        // The three event handlers instead of a simple click handler are needed to prevent the popup
        // from closing when text is selected inside it
        on(this._popup, 'pointerdown', () => { this._draggingPointerOnPopup = false; }),
        on(this._popup, 'pointermove', () => { this._draggingPointerOnPopup = true; }),
        on(this._popup, 'click', () => {
          if (!this._draggingPointerOnPopup) {
            closeAllPopups();
          }
        })
      );
    }
  }

  close () {
    closeAllPopups();
  }

  _isCloseToRightOrLeftMapEdge (positionX) {
    return positionX < MIN_DISTANCE_FROM_EDGE_FOR_ARROW
      || positionX > this._map.getTarget().offsetWidth - MIN_DISTANCE_FROM_EDGE_FOR_ARROW;
  }

}
